/**
 * Colour roles for the Nature world figures ("Four seasons", ART-BIBLE §5.3). Storybook (A) values are
 * hand-picked (warm, slightly muted); Sticker (B) and Pastel (C) are derived by `rolePalette`.
 * Every role is prefixed `nat` so it never clashes with another world. Shared roles (leaf, leafDark,
 * water, white, cream, blush, eye…) come from the base palette.
 */
import { rolePalette } from '../../art/palette';

export const NATURE_PALETTE = rolePalette({
  // spring: tulip + mushroom
  natTulip: '#E5675A',
  natTulipLight: '#F29482',
  natStem: '#6AA55E',
  natMushCap: '#D9554A',
  natMushGill: '#EBD3AE',
  natGrass: '#8CC46E',
  // summer: sunflower + cactus
  natPetal: '#F6C453',
  natPetalDark: '#E9A23B',
  natSeed: '#7A4E32',
  natSeedLight: '#A86F45',
  natCactus: '#86BC6C',
  natCactusDark: '#5A944F',
  natPot: '#D9774A',
  natPotRim: '#EC9A68',
  natBloom: '#F4A3B5',
  // autumn: oak + acorns
  natOak: '#EE9440',
  natOakLight: '#F6BE52',
  natOakRed: '#D9643A',
  natBark: '#8A5A3C',
  natBarkDark: '#6A4330',
  natAcorn: '#E8B676',
  natAcornCap: '#9A6A44',
  natAcornCapDark: '#73492F',
  // winter: pine + cabin
  natPine: '#3F7A5A',
  natPineDark: '#2F5F46',
  natSnow: '#F8FBFD',
  natSnowShade: '#DCE7F0',
  natCabin: '#CF9562',
  natCabinDark: '#A86F45',
  natRoof: '#B9535C',
  natDoor: '#8A5A3C',
  natWindow: '#FFD86B',
  natStone: '#B7AFA3',
  natSmoke: '#E9EEF3',
  // landscapes
  natSky: '#CFEAF5',
  natMountainFar: '#BCCDE2',
  natMountain: '#93ABCB',
  natMountainDark: '#6F86A8',
  natHill: '#8DBE8A',
  natSun: '#F6C453',
  natDusk: '#F3A68C',
  natGlow: '#FAD38C',
  natSea: '#5E9FC4',
  natSeaLight: '#9ED0E2',
  natSand: '#F0D3A0',
  natPalm: '#A8774E',
  natStarfish: '#EE8C6A',
  natShell: '#F8D9D0',
  natCloud: '#FFFFFF',
  natIce: '#CFE6F0',
  natApple: '#D9503F',
  natAppleGreen: '#9CC25A',
  natBasket: '#E0AE68',
  natBasketDark: '#A9743E',
  natRainbowBlue: '#7FB3E0',
  natRainbowViolet: '#B49AD9',
  natLights: '#F27E7E',
  natRobin: '#C9673F',
  natWool: '#7C9CD6',
  natSled: '#C9503F',
  natMug: '#F3EBDD',
  natMugBand: '#7FB0D9',
  natStraw: '#EBCB7C',
  natNest: '#B58653',
  natTea: '#F7F1E6',
  natCan: '#7FB3A8',
  natIceDark: '#9EC4D8',
  natMountainHaze: '#D6E0EE',
});
